export const REPORT_DATA_CHANNELS_BY_SITE= "REPORT_DATA_CHANNELS_BY_SITE";
export const REPORT_DATA_CHANNELS_BY_SITE_SUCCESS = "REPORT_DATA_CHANNELS_BY_SITE_SUCCESS";

export const REPORT_DATA_MORE_CHANNELS_BY_SITE= "REPORT_DATA_MORE_CHANNELS_BY_SITE";
export const REPORT_DATA_MORE_CHANNELS_BY_SITE_SUCCESS = "REPORT_DATA_MORE_CHANNELS_BY_SITE_SUCCESS";